import { DatePipe } from '@angular/common';
import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TokenStorageService } from 'src/app/core/auth/token-storage.service';
import { ApiCallService } from 'src/app/core/services/api-call-service';
import { getdateformatService } from 'src/app/core/services/get-date-format.service';
import { SnackbarCollection } from 'src/app/core/services/snackbar.service';
import { WidgetConfigService } from 'src/app/core/services/widget-config.service';
import { ConfirmationDialogBoxComponent, SuccessDialogComponent } from 'src/app/shared/components/dialog-box';
import { TranslateDynamicText } from 'src/app/shared/pipes/dynamic-translation.pipe';

@Component({
  selector: 'app-customer-subscription-profile',
  templateUrl: './customer-subscription-profile.component.html',
  styleUrls: ['./customer-subscription-profile.component.css']
})
export class CustomerSubscriptionProfileComponent implements OnInit {

  customerDetails;
  customerDetailLoading = false;
  mainTopic = "profile";
  allCustomersListViewDataLoading = false;
  validWidgets = null;
  customerProfilePhoto: string = ''; // Holds the latest profile photo URL
  photoPageIndex: number = 1; // Tracks current page index for photo history pagination
  photoPageSize: number = 10; // Number of photos per page (adjust as needed)
  customerProfilePhotoHistory: any[] = []; // Stores the history of profile photos
  totalPhotos: number = 0; // Total number of profile photos available

  membershipDetails: any = null;
  membershipHistory: any[] = [];
  membershipTiers: any[] = [];
  showTierSelection = false;
  selectedTierId: number | null = null;
  historyPage = 1;
  historyPageSize = 10;
  totalHistoryCount = 0;
  progressPercentage = 0;
  daysLeft = 0;

  visitHistory: any[] = [];
  todayActivity: any[] = [];
  totalVisits: number = 0;
  todayVisits: number = 0;
  last30DaysVisits: number = 0;
  visitHistoryPage = 1;
  visitHistoryPageSize = 10;
  isLoadingVisits = false;
  lastVisitType: 'CHECKIN' | 'CHECKOUT' | null = null;

  isUpgradeMode = false;
  availableTiers: any[] = [];
  upgradeCost: number | null = null;
  showPaymentDetails = false;
  selectedPaymentMode = "CREDIT_CARD";
  selectedPaymentStore;
  paymentRemarks: string = '';

  revCurrency;

  storeFilterList = [{
    storeName: 'None',
    qid: null,
  }];
  selectedStore;
  isAdmin = false;
  userId;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CustomerSubscriptionProfileComponent>,
    private tokenStorage: TokenStorageService,
    private apiCall: ApiCallService,
    private datePipe: DatePipe,
    private date_format: getdateformatService,
    private _snackBar: SnackbarCollection,
    private _widgetConfigService: WidgetConfigService,
    private dialog: MatDialog,
  private _i18nDynamicTranslate: TranslateDynamicText,
    
  ) { }

  async ngOnInit() {
    if (this.tokenStorage.getqId() == 'null') {
      this.isAdmin = true;
    }
    this.userId = this.tokenStorage.getUserId();
    this.revCurrency = sessionStorage.getItem("serviceCurrency");
    this.customerDetails = this.data.customer;
    this.validWidgets = await this._widgetConfigService.getWidget();
    this.loadCustomerProfile(this.customerDetails['customerId']);
    this.loadCustomerProfileHistory();
    this.getStoreDetails();
  }

  closePopup() {
    this.dialogRef.close(this.customerDetails);
  }

  @HostListener('window:scroll', [])
  onScroll(): void {
    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
      if (this.customerProfilePhotoHistory.length < this.totalPhotos) {
        this.loadCustomerProfileHistory();
      }
    }
  }


  tabChange(type) {
    this.mainTopic = type;
    this.historyPage=1;
    if (type === 'membership') {
      this.allCustomersListViewDataLoading = true;
      this.getMembershipTiers()
      this.getMembershipDetails();
      this.getMembershipHistory();
    }
    else if (type === 'checkincheckout') {
      this.loadVisitHistory();
    }
  }

  loadCustomerProfile(customerId) {
    this.apiCall.getCustomerProfilePhoto(customerId)
      .subscribe((response: any) => {
        if (response.message === "success") {
          this.customerProfilePhoto = response.body.urlPath;
        }
      }, (error) => {
        console.error("Failed to fetch profile photo", error);
      });
  }

  loadCustomerProfileHistory() {
    // if (resetPagination) {
    //     this.photoPageIndex = 1;
    //     this.customerProfilePhotoHistory = [];
    // }

    this.apiCall.getCustomerProfilePhotoHistory(this.customerDetails['customerId'], this.photoPageIndex, this.photoPageSize)
      .subscribe((response: any) => {
        if (response.message === "success") {
          this.customerProfilePhotoHistory.push(...response.body.profilePhotos);
          this.totalPhotos = response.body.totalCount;
          this.photoPageIndex++;
        }
      }, (error) => {
        console.error("Failed to fetch photo history", error);
      });
  }

  getDateInFormatForDisplay(dateInp: number): string | null {
    if (!dateInp) return null;
    let date = new Date(dateInp);
    const year = date.getUTCFullYear();
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = monthNames[date.getUTCMonth()];
    const day = date.getUTCDate();
    return `${month} ${day}, ${year}`;
  }

  async getMembershipDetails() {
    try {
      const response = await this.apiCall.getMembershipStatus(
        this.customerDetails.customerId
      ).toPromise();

      if (response['message'] === 'success') {
        this.membershipDetails = response['body'];
        this.calculateProgress();
      }
    } finally {
      this.allCustomersListViewDataLoading = false;
    }
  }

  async getMembershipHistory(resetPagination=true) {
    if (resetPagination) {
      this.historyPage = 1;
      this.membershipHistory = [];
    }
    const response = await this.apiCall.getMembershipHistory(
      this.customerDetails.customerId,
      this.historyPage,
      this.historyPageSize
    ).toPromise();

    if (response['message'] === 'success') {
      this.membershipHistory = response['body'].data;
      this.totalHistoryCount = response['body'].totalCount;
    }
  }

  getMembershipTiers() {
    this.apiCall.getAllMembershipPlans()
      .subscribe((response: any) => {
        if (response.message === "success") {
          this.membershipTiers = response.body;
        }
      }, (error) => {
        console.error("Failed to fetch profile photo", error);
      });
  }

  calculateProgress() {
    if (this.membershipDetails?.subscriptionStartDate && this.membershipDetails?.subscriptionEndDate) {
      const startArray = this.membershipDetails.subscriptionStartDate;
      const endArray = this.membershipDetails.subscriptionEndDate;
      const start = new Date(startArray[0], startArray[1] - 1, startArray[2]);
      const end = new Date(endArray[0], endArray[1] - 1, endArray[2]);
      const adjustedEnd = new Date(end);
      adjustedEnd.setDate(adjustedEnd.getDate() - 1);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const totalDays = (adjustedEnd.getTime() - start.getTime()) / (1000 * 3600 * 24);
      this.daysLeft = Math.max(0, Math.ceil((adjustedEnd.getTime() - today.getTime()) / (1000 * 3600 * 24)));
      this.progressPercentage = totalDays > 0
        ? ((totalDays - this.daysLeft) / totalDays) * 100
        : 0;
    } else {
      this.daysLeft = 0;
      this.progressPercentage = 0;
    }
  }
  

  openUpgradeMembership() {
    this.isUpgradeMode = !this.isUpgradeMode
    this.showTierSelection = !this.showTierSelection;
    this.showPaymentDetails = this.showTierSelection;
    this.resetSelectionState();
    // Filter available tiers based on current membership cost
    this.filterAvailableTiersForUpgrade();
  }

  resetSelectionState() {
    this.selectedTierId = null;
    this.upgradeCost = null;
    this.paymentRemarks = '';
    this.selectedPaymentStore = this.storeFilterList[0];
  }

  filterAvailableTiersForUpgrade() {
    if (!this.membershipDetails || !this.membershipTiers.length) return;

    const currentTier = this.membershipTiers.find(
      tier => tier.tierName === this.membershipDetails.subscriptionName
    );

    if (currentTier) {
      this.availableTiers = this.membershipTiers.filter(
        tier => tier.cost > currentTier.cost
      );
    } else {
      this.availableTiers = [...this.membershipTiers];
    }
  }

  isEligibleForUpgrade(tier: any): boolean {
    if (!this.isUpgradeMode) return true;

    const currentTier = this.membershipTiers.find(
      t => t.tierName === this.membershipDetails.subscriptionName
    );

    console.log(currentTier);
    return currentTier ? tier.cost > currentTier.cost : true;
  }

  selectTier(tierId: number) {
    this.selectedTierId = tierId;

    if (this.isUpgradeMode) {
      this.getUpgradeCost(tierId);
    }
  }

  // Add a method to fetch upgrade cost
  async getUpgradeCost(tierId: number) {
    try {
      const payload = {
        tierId: tierId.toString(),
        action: "ACTIVE",
        provider: "POS_STATION",
        paymentType: "ONE_TIME",
        subscriptionType: "MEMBERSHIP"
      };

      const response = await this.apiCall.getUpgradeCost(
        this.customerDetails.customerId,
        payload
      ).toPromise();

      if (response && response['message'] === 'success') {
        this.upgradeCost = response['body'];
      }
    } catch (error) {
      console.error('Error fetching upgrade cost:', error);
      this.upgradeCost = null;
    }
  }


  toggleMembershipTierSelection() {
    this.isUpgradeMode = false;
    this.showTierSelection = !this.showTierSelection;
    this.showPaymentDetails = this.showTierSelection;
    this.resetSelectionState();

    if (this.showTierSelection) {
      this.availableTiers = [...this.membershipTiers];
    }
  }

  // selectTier(tierId: number) {
  //   this.selectedTierId = tierId;
  // }

  confirmTierSelection() {
    if (!this.selectedTierId) return;

    const dialogRef = this.dialog.open(ConfirmationDialogBoxComponent, {
      panelClass: "no-padding-dialog-popup",
      width: "280px",
      data: {
        subject: this.isUpgradeMode ? `UPGRADE MEMBERSHIP` : `ACTIVATE MEMBERSHIP`,
        message: this.isUpgradeMode 
          ? `Are you sure you want to upgrade the membership?`
          : `Are you sure you want to activate the membership?`,  
        cancelButtonText: "Cancel",
        successButtonText: "Confirm",
      }
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        const payload = {
          tierId: this.selectedTierId.toString(),
          action: "ACTIVE",
          provider: "POS_STATION",
          paymentType: "ONE_TIME",
          subscriptionType: "MEMBERSHIP",
          subscriptionStartDate : new Date().toISOString(),
          modeOfPayment : this.selectedPaymentMode,
          storeId : this.selectedPaymentStore.qid,
          remarks : this.paymentRemarks,
          userId : this.userId,
        };
        await this.updateMembershipStatus(payload);
      
      }
    });
  }

  openCancelConfirmation() {
    const dialogRef = this.dialog.open(ConfirmationDialogBoxComponent, {
      panelClass: "no-padding-dialog-popup",
      width: "280px",
      data: {
        subject: `CANCEL MEMBERSHIP`,
        message: `Are you sure you want to cancel the membership?`,
        cancelButtonText: "No",
        successButtonText: "Yes",
      }
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        await this.updateMembershipStatus({
          action: "CANCELLED",
          provider: "POS_STATION"
        });
      }
    });
  }

  openInactivateConfirmation() {
    const dialogRef = this.dialog.open(ConfirmationDialogBoxComponent, {
      panelClass: "no-padding-dialog-popup",
      width: "280px",
      data: {
        subject: `Upgrade MEMBERSHIP`,
        message: `Are you sure you want to upgrade the membership?`,
        cancelButtonText: "No",
        successButtonText: "Yes",
      }
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        await this.updateMembershipStatus({
          action: "ACTIVE",
          provider: "POS_STATION"
        });
      }
    });
  }

  async updateMembershipStatus(payload: any) {
    try {
      const response = await this.apiCall.updateMembershipStatus(
        this.customerDetails.customerId,
        payload
      ).toPromise();

      if (response['message'] === 'success') {
        this.customerDetails = { ...this.customerDetails, ...response['body'] };
        await this.getMembershipDetails();
        await this.getMembershipHistory();
        this.showTierSelection = false;
        // this._snackBar.success("Membership updated successfully");
        const dialogRef = this.dialog.open(SuccessDialogComponent, {
          panelClass: "no-padding-dialog-popup",
          width: "20%",
          disableClose: true,
          data: {
            message: this._i18nDynamicTranslate.transform("Subscription added sucessfully.", ['POS_PAGE']),
            buttonText: this._i18nDynamicTranslate.transform("Continue", ['POS_PAGE'])
          },
        });
      }
    } catch (error) {
      console.error('Error updating membership status:', error);
      this._snackBar.openSnackBar(error.error.body, 4000);
    }
  }
  isLoadingMembershipHistory = false;


  onHistoryScroll(event: any): void {
    const element = event.target;
    const scrollPosition = element.scrollTop + element.clientHeight;
    const scrollThreshold = element.scrollHeight - 20; 
    if (scrollPosition >= scrollThreshold && 
        !this.isLoadingMembershipHistory && 
        this.membershipHistory.length < this.totalHistoryCount) {
      
      this.loadMoreMembershipHistory();
    }
  }

  async loadMoreMembershipHistory() {
    if (this.isLoadingMembershipHistory) return;
    
    try {
      this.isLoadingMembershipHistory = true;
      this.historyPage++;
      
      const response = await this.apiCall.getMembershipHistory(
        this.customerDetails.customerId,
        this.historyPage,
        this.historyPageSize
      ).toPromise();
  
      if (response['message'] === 'success') {
        this.membershipHistory = [...this.membershipHistory, ...response['body'].data];
        this.totalHistoryCount = response['body'].totalCount;
      }
    } catch (error) {
      console.error('Error loading membership history:', error);
    } finally {
      this.isLoadingMembershipHistory = false;
    }
  }

  formatDate(dateArray: number[]) {
    if (!dateArray) return 'N/A';
    const date = new Date(
      dateArray[0], dateArray[1] - 1, dateArray[2]
    );
    return date.toLocaleDateString('en-US', {
      month: 'short', day: '2-digit', year: 'numeric'
    }).replace(',', '');
  }

  onCheckInScroll(event: any): void {
    const element = event.target;
    const scrollPosition = element.scrollTop + element.clientHeight;
    const scrollThreshold = element.scrollHeight - 20; 
    if (scrollPosition >= scrollThreshold && 
        !this.isLoadingVisits && 
        this.visitHistory.length < this.totalVisits) {
      
      this.loadMoreCheckinHistory();
    }
  }

  async loadMoreCheckinHistory() {
    if (this.isLoadingVisits) return;
    
    try {
      this.isLoadingVisits = true;
      this.visitHistoryPage++;

      const response = await this.apiCall.getVisitHistory(
        this.customerDetails.customerId,
        this.visitHistoryPage,
        this.visitHistoryPageSize
      ).toPromise();

  
      if (response['message'] === 'success') {
        this.visitHistory = [...this.visitHistory, ...response['body'].visitHistory];
        this.totalHistoryCount = response['body'].totalCount;
      }
    } catch (error) {
      console.error('Error loading membership history:', error);
    } finally {
      this.isLoadingVisits = false;
    }
  }

  async loadVisitHistory(resetPagination = true) {
    if (resetPagination) {
      this.visitHistoryPage = 1;
      this.visitHistory = [];
    }

    if (this.isLoadingVisits) return;
    this.isLoadingVisits = true;

    try {
      const response = await this.apiCall.getVisitHistory(
        this.customerDetails.customerId,
        this.visitHistoryPage,
        this.visitHistoryPageSize
      ).toPromise();

      if (response && response['message'] === 'success') {
        this.visitHistory = response['body']['visitHistory'];
        this.totalVisits = response['body']['totalVisits'];
        this.todayVisits = response['body']['visitCounterToday'];
        this.last30DaysVisits = response['body']['visitCounter30Days'];

        // Filter today's activity
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        this.todayActivity = this.visitHistory.filter(visit => {
          const visitDate = new Date(visit.timestamp);
          return visitDate >= today;
        });

        // Determine last visit type
        if (this.visitHistory.length > 0) {
          this.lastVisitType = this.visitHistory[0].type;
        }
      }
    } catch (error) {
      console.error('Error loading visit history:', error);
    } finally {
      this.isLoadingVisits = false;
    }
  }

  async markVisit(type: 'CHECKIN' | 'CHECKOUT') {
    try {
      const merchantId = this.tokenStorage.getMerchantId();
      const storeId = this.isAdmin ? this.selectedStore.qid : this.tokenStorage.getStoreId();

      const payload = {
        customerId: this.customerDetails.customerId,
        merchantId: merchantId,
        storeId: storeId,
        type: type
      };

      const response = await this.apiCall.markVisit(payload).toPromise();

      if (response['message'] === 'success') {
        // Reload visit history to get updated data
        await this.loadVisitHistory(true);
      }
    } catch (error) {
      console.error('Error marking visit:', error);
    }
  }

  // @HostListener('window:scroll', ['$event'])
  // onVisitHistoryScroll(event: any): void {
  //   if (this.mainTopic !== 'checkincheckout') return;

  //   const element = event.target;
  //   if (element.scrollHeight - element.scrollTop === element.clientHeight) {
  //     if (this.visitHistory.length < this.totalVisits) {
  //       this.loadVisitHistory();
  //     }
  //   }
  // }

  formatVisitTime(timestamp: number): string {
    const date = new Date(timestamp);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  }

  formatVisitDate(timestamp: number): string {
    const date = new Date(timestamp);
    return date.toLocaleDateString('en-US', {
      month: 'short', day: '2-digit', year: 'numeric'
    }).replace(',', '');
  }

  getStoreDetails() {
    this.apiCall.getListStore().subscribe(
      (response) => {
        this.storeFilterList = [{
          storeName: 'None',
          qid: null,
        }];
        if (response['body']) {
          response['body'].forEach((storeData) => {
            if (storeData.qid) {
              this.storeFilterList.push({
                'qid': storeData.qid,
                'storeName': storeData.storeName,
              });
            }
          });
          this.selectedStore = this.storeFilterList[0];
          this.selectedPaymentStore = this.storeFilterList[0];
        }
      },
      (err) => {
      }
    );
  }



}
